<div class="w-100 d-flex flex-column pb-5 overflow-x-hidden h-100">
  <div class="d-flex position-relative">
    <app-new-sidebar
      (sidebarHovered)="handleSidebarHover($event)"></app-new-sidebar>
    <app-new-header
      class="new-header"
      [isSidebarHovered]="isSidebarHovered"></app-new-header>
  </div>

  <div class="width-page-close-sidebar">
    <router-outlet></router-outlet>
  </div>
</div>
